export const mapModelToSubscription = (model, customerId) => {
	const {
		subscriptionShippingMonths,
		subscriptionProducts,
		paymentMethod,
		shippingAddress,
		customer,
		...subscription
	} = model;
	const entity = {
		...subscription,
		customerId,
		subscriptionProducts: {
			create: subscriptionProducts,
		},
		subscriptionShippingMonths: {
			create: subscriptionShippingMonths,
		},
	};

	if (shippingAddress) {
		const { id, ...address } = shippingAddress;
		entity.customerAddress = {
			create: {
				customerId,
				...address,
			},
		};
	}

	if (paymentMethod) {
		const pm = {
			customerId,
			externalId: "",
			creditCard: {
				create: paymentMethod.card,
			},
		};
		if (subscription.shippingAddressId) {
			pm.addressId = subscription.shippingAddressId;
		} else {
			pm.customerAddress = entity.customerAddress;
		}
		entity.paymentMethod = {
			create: pm,
		};
	}

	return entity;
};
